import type { SemHeroModule } from '~/contracts/sem';
import useImageViews from '~/hooks/sem/useImageViews';
import BodyStyleCarousel from './BodystyleCarousel';
import {
  Title,
  SubTitle,
  InnerWrapper,
  HeroImg,
  TopSection
} from './Hero.styles';
import MakeModelForm from './MakeModelForm';
import SemTrackWrapper from '../SemTrackWrapper';

type HeroImageProps = {
  imageUrl: string;
  shouldShow?: boolean;
};

const HeroImage = ({ imageUrl, shouldShow = false }: HeroImageProps) => {
  return shouldShow ? (
    <picture>
      <source srcSet={imageUrl} media="(min-width: 1440px)" />
      <HeroImg src={imageUrl} alt="Hero" />
    </picture>
  ) : null;
};

type OwnProps = Omit<SemHeroModule, '__typename'>;

function Hero({
  id,
  image,
  imageViews,
  subtitle,
  title,
  variant,
  semModularRequest
}: OwnProps) {
  const { imageUrl, shouldShowImageOnMobile, shouldShowImageOnDesktop } =
    useImageViews(imageViews, image);
  if (!id) return null;

  const { buttonText, dropdownOptions, formType, pillOptions } = variant;

  return (
    <SemTrackWrapper sectionName="Hero">
      <InnerWrapper>
        <TopSection>
          <div className="flex flex-col m:min-w-[290px] m:grow">
            <Title>{title}</Title>
            <SubTitle>{subtitle}</SubTitle>
            <div className="flex m:hidden">
              <HeroImage
                imageUrl={imageUrl}
                shouldShow={shouldShowImageOnMobile}
              />
            </div>
            <MakeModelForm
              buttonText={buttonText}
              dropdownOptions={dropdownOptions}
              formType={formType}
              semModularRequest={semModularRequest}
            />
          </div>
          <div className="hidden m:flex m:grow">
            <HeroImage
              imageUrl={imageUrl}
              shouldShow={shouldShowImageOnDesktop}
            />
          </div>
        </TopSection>
        {pillOptions && (
          <div className="w-full">
            <BodyStyleCarousel bodystyles={pillOptions} />
          </div>
        )}
      </InnerWrapper>
    </SemTrackWrapper>
  );
}

export default Hero;
